export default __webpack_public_path__ + "dbb8c797a70e34413a8fea32a4f0afa3.jpg";